import {AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";
import {RequestTimeSettingDto} from "../dto/RequestTimeSettingDto";

export const RequestTimeSettingApi = {

    getRequestTimeSettingList: async () => {
        try {
            const requestUrl = '/v1/vms/requestTimeSetting/list';
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getRequestTimeActualList: async (arriveDate: string, classify: string) => {
        try {
            const params = new Map<string, string>();
            params.set('arriveDate', arriveDate);
            params.set('classify', classify);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/requestTimeSetting/getActualList', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createRequestTimeSetting: async (body: RequestTimeSettingDto) => {
        try {
            const requestUrl = '/v1/vms/requestTimeSetting/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    updateRequestTimeSetting: async (body: RequestTimeSettingDto) => {
        try {
            const requestUrl = '/v1/vms/requestTimeSetting/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteRequestTimeSetting: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/requestTimeSetting/delete', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
